import { Zone } from '@/core/api/entities/zone/zone'
import { useAccountConfig } from '@/core/hooks/useAccountConfig'
import { useGetZoneOccupation } from '@/core/hooks/useZone'

interface UseGetOccupationParams {
	zone?: Zone
}

/**
 * Hook to get occupation data for a zone
 * Only executes when the zone has an integration source
 * Fetches data from the last 24 hours (yesterday to now at the same time)
 * Date calculation is handled automatically in useGetZoneOccupation
 */
export const useGetOccupation = ({ zone }: UseGetOccupationParams) => {
	// Only fetch occupation data if zone has an integration source
	const hasIntegrationSource = !!zone?.integrationSource
	const isEnabled = hasIntegrationSource && !!zone?.accountId && !!zone?.id

	return useGetZoneOccupation({
		accountId: zone?.accountId,
		zoneId: zone?.id,
		config: useAccountConfig({}),
		options: {
			enabled: isEnabled,
		},
	})
}
